export const abscenceTypesInDays: string[] = [
    "Licença por Falecimento",
    "Licença Parental",
    "Licença Casamento",
    "Feriado",
    "Férias",
    "Em Admissão",
    "Compensação",
    "Período não trabalhado",
    "Dia de Descanso (Colaboradores de Suporte)",
    "Cessação de Contrato",
];